import { Entity } from '@adornis/baseql/decorators.js';
import { type ValidationMeta } from '@adornis/validation/validator.js';
import { Mitarbeiter } from './Mitarbeiter.js';

/**
 * @entity VerwaltungsMitarbeiter
 */
@Entity()
export class VerwaltungsMitarbeiter extends Mitarbeiter {
  public static override _class = 'VerwaltungsMitarbeiter';

  public static override readableName = 'Verwaltungsmitarbeiter:in';

  override async validate(
    options?: ValidationMeta & {
      validateOmitted?: boolean;
    },
  ): Promise<void> {}
}
